module.exports = __webpack_public_path__ + "static/img/10.e87fd0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screenshot/10.png
// module id = jGJH
// module chunks = 0